import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=c70fb4ec&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"
import style0 from "./Frontend.vue?vue&type=style&index=0&id=c70fb4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70fb4ec",
  null
  
)

export default component.exports